/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from '@angular/core';
import { GenericMessage } from 'src/app/shared/shared-components/generic-message/generic-message.interface';

/** GenericMessageService */
@Injectable({
  providedIn: 'root',
})
export class GenericMessageService {

  /** successMessage */
  private _successMessage: GenericMessage;

  /** errorMessage */
  private _errorMessage: GenericMessage;

  /**
   * GenericMessageService
   */
  public constructor () {}

  /** getSuccessMessage
   * @method to get the success message
   * @returns {GenericMessage} successMessage
   */
  public get successMessage (): GenericMessage {
    return this._successMessage;
  }

  /** setSuccessMessage
   * @method to set the success message
   * @param successMessage GenericMessage
   */
  public set successMessage (successMessage: GenericMessage) {
    this._successMessage = successMessage;
  }

  /** getErrorMessage
   * @method to get the error message
   * @returns {GenericMessage} errorMessage
   */
   public get errorMessage (): GenericMessage {
    return this._errorMessage;
  }

  /** setSuccessMessage
   * @method to set the success message
   * @param errorMessage GenericMessage
   */
  public set errorMessage (errorMessage: GenericMessage) {
    this._errorMessage = errorMessage;
  }
}
